<template>
  <div>
    <b-row class="row justify-content-between">
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Sales By :</label>
        <p class="viewValue">{{ selectedSalesBy }}</p>
      </b-col>

      <b-col
        md="4"
        class="mt-2"
        :style="selectedSalesBy !== 'Direct' ? '' : 'display: none'"
      >
        <label class="viewLabel">{{ selectedSalesByLabel }}</label>
        <p class="viewValue">{{ data.selectedteam && hasValue(data.selectedteam.name) ? data.selectedteam.name : "NA" }}</p>
      </b-col>
      <!-- <b-col md="4" class="mt-2" :style="selectedSalesBy == 'Employee' ? '' : 'display: none'">
          <label class="viewLabel">{{ selectedSalesByLabel }}</label>
          <p class="viewValue">{{data.selectedteam && data.selectedteam ? data.selectedteam[0].name : ''}}</p>
        </b-col>
        <b-col md="4" class="mt-2" :style="selectedSalesBy == 'Franchise' && selectedSalesBy != 'Direct' ? '' : 'display: none'">
          <label class="viewLabel">{{ selectedSalesByLabel }}</label>
          <p class="viewValue">{{data.selectedteam && data.selectedteam.length>0 ? data.selectedteam[0].name : ''}}</p>
        </b-col> -->

      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Booking Date :</label>
        <p class="viewValue">{{ bookingdate }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Booking Type :</label>
        <p class="viewValue">{{ hasValue(data.bookingtype) ? data.bookingtype : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Email :</label>
        <p class="viewValue">{{ data.selectedteam && hasValue(data.selectedteam.email) ? data.selectedteam.email : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Phone No :</label>
        <p class="viewValue">{{ data.selectedteam && hasValue(data.selectedteam.mobile) ? data.selectedteam.mobile : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Username :</label>
        <p class="viewValue">
          {{ getUsername }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Photo :</label>
        <div style="width: 100px">
          <attachment v-if="getPhoto" :data="getPhoto" />
          <p v-else class="viewValue">NA</p>
        </div>
      </b-col>
      <b-col md="12" class="mt-2">
        <h3>Application Form</h3>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> In SIR?:</label>
        <p class="viewValue">{{ sir }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Village Name (New Survay No.) :</label>
        <p class="viewValue">
          {{ data.village && hasValue(data.village.villagename) ? data.village.villagename : "NA" }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Zone:</label>
        <p class="viewValue">{{ getZone }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Selelct T.P. :</label>
        <p class="viewValue">{{ getTpNo }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Selelct Sub T.P. :</label>
        <p class="viewValue">{{ hasValue(data.subtpno) ? data.subtpno : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Survey No. New:</label>
        <p class="viewValue">
          {{ getSurveyNoNew }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Old Survay No. :</label>
        <p class="viewValue">
          {{ getOldSurveyNo }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> F.P. No. :</label>
        <p class="viewValue">{{ hasValue(data.fpno) ? data.fpno : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> F.P. Area /Land size (In Sq. Yard) :</label>
        <p class="viewValue">{{ hasValue(data.fparea) ? data.fparea : "NA" }}</p>
      </b-col>

      <b-col md="12" class="mt-2">
        <h3>Rate Details</h3>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> CP Rate :</label>
        <p class="viewValue">{{ hasValue(data.cprate) ? data.cprate : "NA" }}</p>
      </b-col>
      <b-col
        md="4"
        class="mt-2"
        :style="selectedPaymentThrough == 'By UPI' ? '' : 'Display:none'"
      >
        <label class="viewLabel"> Bulk Land Rate:</label>
        <p class="viewValue">{{ hasValue(data.landrate) ? data.landrate : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> With NA? :</label>
        <p class="viewValue">{{ hasValue(data.withna) ? data.withna : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Remarks:</label>
        <p class="viewValue">{{ hasValue(data.remarks) ? data.remarks : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Land Jantri Rate/ Govt. Guideline Rs. :</label>
        <p class="viewValue">{{ hasValue(data.jantrirate) ? data.jantrirate : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Payment Type :</label>
        <p class="viewValue">{{ hasValue(data.paymenttype) ? data.paymenttype : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="paymenttype == 'Token'">
        <label class="viewLabel"> Payment Token :</label>
        <p class="viewValue">{{ hasValue(data.paymenttoken) ? data.paymenttoken : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Payment Terms Days:</label>
        <p class="viewValue">{{ hasValue(data.paymenttermday) ? data.paymenttermday : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Payment Through :</label>
        <p class="viewValue">{{ hasValue(data.paymentthrough) ? data.paymentthrough : "NA" }}</p>
      </b-col>
      <b-col md="12">
        <h3>Payment Details</h3>
      </b-col>
      <b-col md="4" class="mt-2" v-if="noChequeField">
        <label class="viewLabel"> Bank Name :</label>
        <p class="viewValue">{{ hasValue(data.bankname) ? data.bankname : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="noChequeField">
        <label class="viewLabel"> Reference Number:</label>
        <p class="viewValue">{{ hasValue(data.refno) ? data.refno : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="noChequeField">
        <label class="viewLabel"> Upload Receipt:</label>
        <div v-if="hasValue(data.bankreceipt)">
          <attachment :data="data.bankreceipt" />
        </div>
        <p v-else class="viewValue">NA</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="noChequeField">
        <label class="viewLabel"> Date:</label>
        <p class="viewValue">{{ hasValue(data.bankdate) ? data.bankdate : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="noChequeField">
        <label class="viewLabel"> Remarks:</label>
        <p class="viewValue">{{ hasValue(data.bankremarks) ? data.bankremarks : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="chequeField">
        <label class="viewLabel"> Cheque No :</label>
        <p class="viewValue">{{ hasValue(data.chequeno) ? data.chequeno : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="chequeField">
        <label class="viewLabel"> Bank Name :</label>
        <p class="viewValue">{{ hasValue(data.bankname) ? data.bankname : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="chequeField">
        <label class="viewLabel"> Cheque Date:</label>
        <p class="viewValue">{{ hasValue(data.chequedate) ? data.chequedate : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2" v-if="chequeField">
        <label class="viewLabel"> Status :</label>
        <p class="viewValue">{{ hasValue(data.status) ? data.status : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel">Total Payment :</label>
        <p class="viewValue">{{ hasValue(data.totalpayment) ? data.totalpayment : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> First Payment:</label>
        <p class="viewValue">{{ hasValue(data.firstpayment) ? data.firstpayment : "NA" }}</p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Remaining Payment :</label>
        <p class="viewValue">{{ hasValue(data.remainingpayment) ? data.remainingpayment : "NA" }}</p>
      </b-col>
      <b-col md="12">
        <h3>Customer Details</h3>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Title :</label>
        <p class="viewValue">
          {{ getCustomerField('title') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Customer Name :</label>
        <p class="viewValue">
          {{ getCustomerField('name') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Address :</label>
        <p class="viewValue">
          {{ getCustomerAddress }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Pin Code :</label>
        <p class="viewValue">
          {{ getCustomerField('perpincode') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> City :</label>
        <p class="viewValue">
          {{ getCustomerField('curcity') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Area :</label>
        <p class="viewValue">
          {{ getCustomerField('perarea') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> state :</label>
        <p class="viewValue">
          {{ getCustomerField('curstate') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Country :</label>
        <p class="viewValue">
          {{ getCustomerField('country') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> DOB :</label>
        <p class="viewValue">
          {{ getCustomerField('birthdate') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Mobile No :</label>
        <p class="viewValue">
          {{ getCustomerField('mobile') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Email ID :</label>
        <p class="viewValue">
          {{ getCustomerField('email') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Aadhar No :</label>
        <p class="viewValue">
          {{ getCustomerField('aadharcardno') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Pan No :</label>
        <p class="viewValue">
          {{ getCustomerField('panno') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Nominee :</label>
        <p class="viewValue">
          {{ getNomineeField('nominee') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Nominee Relationship :</label>
        <p class="viewValue">
          {{ getNomineeField('nomineerelation') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Nominee Phone :</label>
        <p class="viewValue">
          {{ getNomineeField('nomineephone') }}
        </p>
      </b-col>
      <b-col md="4" class="mt-2">
        <label class="viewLabel"> Nominee DOB :</label>
        <p class="viewValue">
          {{ getNomineeField('nomineedob') }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BFormFile,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
} from "bootstrap-vue";
import axios from "@/components/axios";
import Attachment from "@/components/Attechment.vue";
export default {
  components: {
    BFormCheckbox,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BFormFile,
    Attachment,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BImg,
  },
  props: {
    closepopup: {
      default: () => {},
    },
    selectedID: {
      default: 0,
    },
  },
  data() {
    return {
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      data: {},
      loginData: JSON.parse(localStorage.getItem("userData")),
      selectedPaymentThrough: "",
      selectedTeam: "",
      label: "",
      selectedSalesBy: "",
      selectedSalesByLabel: "",
      userType: "",
      email: "",
      bookingdate: "",
      sir: "",
      noChequeField: false,
      chequeField: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getlandsalesById/${this.selectedID}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.data = Array.isArray(json.data.data) ? json.data.data[0] : json.data.data;
          this.selectedPaymentThrough = this.data.paymentthrough
            ? this.data.paymentthrough
            : "";
          this.selectedSalesBy = this.data.selecttype ? this.data.selecttype : "";
          this.selectedSalesByLabel = this.getLabelForSelection(this.selectedSalesBy);
          this.bookingdate = this.data.bookingdate ? this.data.bookingdate : "";
          this.sir = this.data.sir ? this.data.sir : "No";
          this.handleSelectPayment(this.data.paymentthrough);
          
          // Fetch full customer details if only limited data is available
          this.fetchFullCustomerDetails();
        })
        .catch((error) => console.log(error, "error"));
    },
    handleSelectPayment(e) {
      const name = e;
      if (name == "By Cheque") {
        this.chequeField = true;
      } else {
        this.chequeField = false;
      }
      if (name !== "By Cash" && name !== "By Cheque" && name !== "By UPI") {
        this.noChequeField = true;
      } else {
        this.noChequeField = false;
      }
    },
    getLabelForSelection(selection) {
      if (selection === "Franchise") {
        return "Franchise";
      } else if (selection === "CompanyAssociatePartner") {
        return "CompanyAssociatePartner";
      } else if (selection === "Employee") {
        return "Employee";
      } else {
        return "Sales By Selection";
      }
    },
    async fetchFullCustomerDetails() {
      // Get the first customer ID from customers array or customer object
      let customerId = null;
      
      if (this.data.customers && Array.isArray(this.data.customers) && this.data.customers.length > 0) {
        customerId = this.data.customers[0].id;
      } else if (this.data.customer) {
        if (Array.isArray(this.data.customer) && this.data.customer.length > 0) {
          customerId = this.data.customer[0].id;
        } else if (typeof this.data.customer === 'object' && this.data.customer.id) {
          customerId = this.data.customer.id;
        }
      }
      
      // If we have a customer ID and the customer data doesn't have full details, fetch them
      if (customerId) {
        const customer = this.getCurrentCustomer();
        // Check if we have limited data (only basic fields) - if missing address fields, fetch full details
        if (customer && (!customer.curaddressline1 && !customer.curcity && !customer.curstate)) {
          try {
            await axios({
              method: "GET",
              url: `${this.baseApi}/getusersbyid/${customerId}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
            })
            .then((response) => {
              if (response.data.data && response.data.data.length > 0) {
                const fullCustomerDetails = response.data.data[0];
                // Merge full details with existing customer data using Vue.set for reactivity
                if (this.data.customers && Array.isArray(this.data.customers) && this.data.customers.length > 0) {
                  this.$set(this.data.customers, 0, { ...this.data.customers[0], ...fullCustomerDetails });
                } else if (this.data.customer) {
                  if (Array.isArray(this.data.customer)) {
                    this.$set(this.data.customer, 0, { ...this.data.customer[0], ...fullCustomerDetails });
                  } else {
                    this.$set(this.data, 'customer', { ...this.data.customer, ...fullCustomerDetails });
                  }
                }
              }
            })
            .catch((error) => console.log(error, "error fetching customer details"));
          } catch (error) {
            console.log(error, "error");
          }
        }
      }
    },
    getCurrentCustomer() {
      // Get the current customer object
      if (this.data.customers && Array.isArray(this.data.customers) && this.data.customers.length > 0) {
        return this.data.customers[0];
      } else if (this.data.customer) {
        if (Array.isArray(this.data.customer) && this.data.customer.length > 0) {
          return this.data.customer[0];
        } else if (typeof this.data.customer === 'object') {
          return this.data.customer;
        }
      }
      return null;
    },
    getCustomerField(fieldName) {
      const customer = this.getCurrentCustomer();
      if (customer && customer[fieldName] != null && customer[fieldName] !== '') {
        return customer[fieldName];
      }
      return "NA";
    },
    hasValue(value) {
      // Check if value exists (not null, not undefined, not empty string)
      // For numbers, 0 is a valid value
      return value != null && value !== '';
    },
    getNomineeField(fieldName) {
      // Nominee fields are stored at the land sales level, not in customer object
      // Check multiple possible field name variations
      if (fieldName === 'nominee') {
        // Check for nominee or nomineename
        if (this.hasValue(this.data.nominee)) {
          return this.data.nominee;
        }
        if (this.hasValue(this.data.nomineename)) {
          return this.data.nomineename;
        }
      } else if (fieldName === 'nomineerelation') {
        // Check for nomineerelation or nomineerelationship
        if (this.hasValue(this.data.nomineerelation)) {
          return this.data.nomineerelation;
        }
        if (this.hasValue(this.data.nomineerelationship)) {
          return this.data.nomineerelationship;
        }
      } else if (fieldName === 'nomineephone') {
        // Check for nomineephone or nomineePhone
        if (this.hasValue(this.data.nomineephone)) {
          return this.data.nomineephone;
        }
        if (this.hasValue(this.data.nomineePhone)) {
          return this.data.nomineePhone;
        }
      } else if (fieldName === 'nomineedob') {
        if (this.hasValue(this.data.nomineedob)) {
          return this.data.nomineedob;
        }
      }
      
      // Fall back to customer data if not found in main data
      const customer = this.getCurrentCustomer();
      if (customer) {
        if (fieldName === 'nominee' && this.hasValue(customer.nomineename)) {
          return customer.nomineename;
        }
        if (this.hasValue(customer[fieldName])) {
          return customer[fieldName];
        }
      }
      
      return "NA";
    },
  },
  computed: {
    getUsername() {
      // First check if customers array exists (from customerjson)
      if (this.data.customers && Array.isArray(this.data.customers) && this.data.customers.length > 0) {
        if (this.hasValue(this.data.customers[0].username)) {
          return this.data.customers[0].username;
        }
      }
      // Fall back to customer array
      if (this.data.customer && Array.isArray(this.data.customer) && this.data.customer.length > 0 && this.hasValue(this.data.customer[0].username)) {
        return this.data.customer[0].username;
      }
      // Check if customer is an object (not array)
      if (this.data.customer && typeof this.data.customer === 'object' && !Array.isArray(this.data.customer) && this.hasValue(this.data.customer.username)) {
        return this.data.customer.username;
      }
      if (this.data.selectedteam && this.hasValue(this.data.selectedteam.username)) {
        return this.data.selectedteam.username;
      }
      return "NA";
    },
    getPhoto() {
      if (this.data.selectedteam && this.data.selectedteam.profile_image) {
        return this.data.selectedteam.profile_image;
      }
      return null;
    },
    getZone() {
      if (this.data.zone) {
        if (typeof this.data.zone === 'object' && this.hasValue(this.data.zone.name)) {
          return this.data.zone.name;
        }
        if (typeof this.data.zone === 'string' && this.hasValue(this.data.zone)) {
          return this.data.zone;
        }
      }
      return "NA";
    },
    getTpNo() {
      if (this.hasValue(this.data.tpno)) {
        return this.data.tpno;
      }
      return "NA";
    },
    getSurveyNoNew() {
      // Check if village is an object with surveynonew
      if (this.data.village && typeof this.data.village === 'object' && !Array.isArray(this.data.village) && this.hasValue(this.data.village.surveynonew)) {
        return this.data.village.surveynonew;
      }
      // Check if village is an array
      if (this.data.village && Array.isArray(this.data.village) && this.data.village.length > 0 && this.hasValue(this.data.village[0].surveynonew)) {
        return this.data.village[0].surveynonew;
      }
      // Check for newsurveyno field directly
      if (this.hasValue(this.data.newsurveyno)) {
        return this.data.newsurveyno;
      }
      return "NA";
    },
    getOldSurveyNo() {
      // Check if village is an object with surveynoold
      if (this.data.village && typeof this.data.village === 'object' && !Array.isArray(this.data.village) && this.hasValue(this.data.village.surveynoold)) {
        return this.data.village.surveynoold;
      }
      // Check if village is an array
      if (this.data.village && Array.isArray(this.data.village) && this.data.village.length > 0 && this.hasValue(this.data.village[0].surveynoold)) {
        return this.data.village[0].surveynoold;
      }
      // Check for oldsurveyno field directly
      if (this.hasValue(this.data.oldsurveyno)) {
        return this.data.oldsurveyno;
      }
      return "NA";
    },
    getCustomerAddress() {
      const customer = this.getCurrentCustomer();
      if (customer) {
        const address1 = customer.curaddressline1 || '';
        const address2 = customer.curaddressline2 || '';
        const fullAddress = `${address1} ${address2}`.trim();
        return fullAddress || "NA";
      }
      return "NA";
    },
  },
};
</script>
<style>
.viewLabel {
  font-size: 15px !important;
  font-weight: 500 !important;
}

.viewValue {
  font-size: 15px !important;
  color: black;
}
</style>
